import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const paymentModule = {
  namespaced: true,
  state: {
    payments: null,
    payment: null,
    isLoading: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  mutations,
  actions,
  getters,
};

export default paymentModule;
